import { FC, useState } from "react";

// * Components
import Chart from "./Сhart/Сhart";
import TooltipButton from "../../TooltipButton";
import BroadcastDataChannel from "./BroadcastDataChannel/BroadcastDataChannel";

// * Hooks
import { useGetBroadcastQuery } from "../../../features/api/apiSlice";
import { useSocketApi } from "../../../hooks/useSocketApi";
import { useScreenWidth } from "../../../hooks/useScreenWidth";

// * Props
import { BroadcastDataProps } from "./BroadcastData.interface";

//* Styles
import styles from "./BroadcastData.module.css";

const BroadcastData: FC<BroadcastDataProps> = ({ broadcastId }) => {
  const { isMobile } = useScreenWidth();
  const { data: broadcast } = useGetBroadcastQuery(broadcastId);
  const [ bitrateChartData, setBitrateChartData ] = useState(broadcast?.bitrates);
  const getBitrateChartData = (data: number[]) => {
    return data.map((bitrate) => ({bitrate: bitrate}));
  };

  useSocketApi({
    broadcastId,
    onBroadcastStatusUpdated({ bitrates }) {
      setBitrateChartData(bitrates);
    },
  });
  return (
    <div className={styles["broadcast-data"]}>
        <div className={styles["broadcast-data__title"]}>
          <span className={styles["broadcast-data__title"]}>Битрейт</span>
          {!isMobile &&
            <TooltipButton
                position="bottom-right"
                text="На этом графике вы можете отслеживать изменения битрейта своей трансляции в реальном времени."
            />
          }
        </div>
        <Chart data={bitrateChartData ? getBitrateChartData(bitrateChartData) : undefined} />
        <div className={styles["broadcast-data__title"]}>
          <span className={styles["broadcast-data__title"]}>Каналы</span>
          {!isMobile &&
            <TooltipButton
                position="top-right"
                text="Здесь отображается время текущей непрерывной работы потока на каждую площадку в секундах."
            />
          }
        </div>
        <div className={styles["broadcast-data__channels-container"]}>
          {broadcast?.restream_templates.map((channel) => (
            <BroadcastDataChannel key={channel.id} channel={channel} broadcast={broadcast}/>
          ))}
        </div>
    </div>
  );
};

export default BroadcastData;
